// src/components/Eventos/DownloadTrackLiffButton.js

import React from 'react';
import { Button } from '@mui/material';

const DownloadTrackLiffButton = ({ heatDetails, rankings, getParticipantResults }) => {
  // Función para formatear el heat con dos dígitos (ej. "01")
  const formatHeat = (heat) => {
    return String(heat).padStart(2, '0');
  };

  // Función para generar y descargar el archivo .lif
  const handleDownloadLiff = () => {
    // Generar la fila del evento (header)
    const eventRow = [
      heatDetails.eventNumber || '',
      heatDetails.round || '',
      formatHeat(heatDetails.heat),
      heatDetails.eventName || '',
      heatDetails.eventCode || '',
      heatDetails.wind || '',
      heatDetails.windUnit || '',
      heatDetails.template || '',
      heatDetails.captureTime || '',
      heatDetails.captureDuration || '',
      heatDetails.distance || '',
      heatDetails.startTime || '',
      heatDetails.windMode || '',
      heatDetails.laptimeInfo || '',
    ].join(',');

    // Generar las filas de competidores
    // Generate competitor rows
    const competitorRows = heatDetails.participants.map((participant) => {
      const results = getParticipantResults(
        heatDetails.eventNumber,
        heatDetails.round,
        heatDetails.heat,
        participant.idNumber
      ) || {};

      // Access the correct ranking entry for the participant
      const rankingEntry = rankings[
        `${heatDetails.eventNumber}_${heatDetails.round}_${heatDetails.heat}`
      ]?.find((r) => r.id === participant.idNumber);
      const place = results.special || (rankingEntry ? rankingEntry.place : '');

      return [
        place, // Ensure place is included here
        participant.idNumber,
        participant.lane || '',
        participant.fullName.split(' ').slice(1).join(' ') || '',
        participant.fullName.split(' ')[0] || '',
        participant.affiliation || '',
        results.time || '',
        results.license || '',
        results.deltaTime || '',
        results.reacTime || '',
        results.lap || '',
        results.timeTrialStart || '',
        results.user1 || '',
        results.user2 || '',
        results.user3 || '',
        results.deltaTime2 || '',
        results.deltaTime3 || '',
        results.speed || '',
        results.pace || '',
      ].join(',');
    });

    // Usar '\r\n' para que las líneas sean estilo Windows (CRLF)
    const fileContent = [eventRow, ...competitorRows].join('\r\n');

    const blob = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Formatear el nombre del archivo, asegurando que el heat tenga dos dígitos
    const fileName = `${heatDetails.eventNumber}-${heatDetails.round}-${formatHeat(heatDetails.heat)}.lif`;

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Button variant="contained" color="primary" onClick={handleDownloadLiff}>
      Descargar archivo .lif
    </Button>
  );
};

export default DownloadTrackLiffButton;
